import axios from "axios";

import { getToken } from "../utils/cookies";

export const workOrderRequest = axios.create({
  baseURL: process.env.REACT_APP_WORK_ORDER_API,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    accept: "application/json",
  },
});
export const initWorkOrderdApiInterceptors = () => {
  workOrderRequest.interceptors.request.use(
    (config) => {
      config.headers["Authorization"] = `Bearer ${getToken()}`;
      return config;
    },
    (error) => {
      console.error("Error in workOrderInterceptors", error);
      return Promise.reject(error);
    }
  );
};

////////////////////////////////////////////////////////////////////////////////////////////////////

export async function getWorkOrderFields() {
  return workOrderRequest({
    method: "get",
    url: "/apiModelSchema/workOrder",
  });
}

export async function getProductFields() {
  return workOrderRequest({
    method: "get",
    url: "/apiModelSchema/product",
  });
}

export async function getWorkOrderOpHistoryFields() {
  return workOrderRequest({
    method: "get",
    url: "/apiModelSchema/workOrderOpHistory",
  });
}

export async function getRouteFields() {
  return workOrderRequest({
    method: "get",
    url: "/apiModelSchema/route",
  });
}

export async function getOperationFields() {
  return workOrderRequest({
    method: "get",
    url: "/apiModelSchema/operation",
  });
}

export async function getWorkerFields() {
  return workOrderRequest({
    method: "get",
    url: "/apiModelSchema/worker",
  });
}
